// import React, { useEffect, useState } from 'react';
// import Table from 'react-bootstrap/Table';
// import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
// import Navbar from '../../Components/Navbar';
// import '../Secretary/Table.css';
// import axios from 'axios';
// import { API_BASE_URL } from '../../config';
// export default function ViewApplication() {
//   const [applications, setApplications] = useState([]);
//   const [filteredApplications, setFilteredApplications] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [currentAppId, setCurrentAppId] = useState(null);
//   const [uploading, setUploading] = useState(false);

//   useEffect(() => {
//     // Fetch applications from the PHP script
//     fetchApplications();
//   }, []);

//   const fetchApplications = async () => {
//     try {
//         // Use axios for a GET request
//         const response = await axios.get('/RequestAgreement.php');

//         // Set the fetched data to state variables
//         setApplications(response.data); 
//         setFilteredApplications(response.data); 
//     } catch (error) {
//         console.error('Error fetching applications:', error);
//     }
// };


//   const handleUploadClick = (id) => {
//     setCurrentAppId(id); // Set the current application ID
//     setShowModal(true); // Open the modal
//   };

//   const handleFileChange = (e) => {
//     setSelectedFile(e.target.files[0]); // Store the selected file
//   };
  
//   const handleRequestClick = async (id) => {
//     const selectedApp = applications.find((app) => app.Id === id);
//     if (!selectedApp) {
//       alert("Application not found.");
//       return;
//     }
  
//     const email = selectedApp.email;
//     const subject = "Application Granted for Funding";
//     const message = `
//       Dear ${selectedApp.name},<br><br>
//       We are pleased to inform you that your application titled <b>${selectedApp.projectTitle}</b>
//       has been approved for funding.<br>
//       <b>Start Date:</b> ${selectedApp.startDate}<br>
//       <b>Period:</b> ${selectedApp.period}<br>
//       <b>Approved Amount:</b> LKR ${selectedApp.amount}<br><br>
//       Please log in to the grant management system at https://rgms.pdn.ac.lk/. Navigate to Application Details > More details > Agreement to download the agreement. Once the Principal Investigator (PI) and Co-Investigators (Co-Is) have signed the agreement, please upload it to the portal.<br><br>
//       Best regards,<br>
//       University of Peradeniya.
//     `;
  
//     try {
//       const response = await axios.post('/EmailRequest.php', {
//         email,
//         subject,
//         message,
//         appId: id,
//       });
  
//       if (response.data.status === 'success') {
//         alert('Email sent and agreement table updated successfully.');
  
//         // Update the applications state to reflect the change
//         setApplications((prevApplications) =>
//           prevApplications.map((app) =>
//             app.Id === id ? { ...app, requested: 1 } : app
//           )
//         );
  
//         setFilteredApplications((prevFilteredApplications) =>
//           prevFilteredApplications.map((app) =>
//             app.Id === id ? { ...app, requested: 1 } : app
//           )
//         );
//       } else {
//         alert(`Failed to send email: ${response.data.message}`);
//       }
//     } catch (error) {
//       console.error('Error sending email:', error);
//       alert('An error occurred while sending the email.');
//     }
//   };
  
//   const handleFileUpload = async () => {
//     if (selectedFile) {
//         setUploading(true); // Start uploading
//         const formData = new FormData();
//         formData.append('app_ID', currentAppId); // Attach the app_ID
//         formData.append('uploadedFile', selectedFile); // Attach the file

//         try {
//             // Use axios to post the form data to the server
//             const response = await axios.post(`${API_BASE_URL}/RequestAgreement.php`, formData, {
//                 headers: {
//                     'Content-Type': 'multipart/form-data', // Important to set this for file uploads
//                 },
//             });

//             // Handle the response from the server
//             if (response.data.status === 'success') {
//                 alert(response.data.message);
//                 setShowModal(false); // Close the modal
//                 fetchApplications(); // Refresh the list of applications
//             } else {
//                 alert(response.data.message);
//             }
//         } catch (error) {
//             console.error('Error uploading file:', error);
//             alert('An error occurred while uploading the file.');
//         } finally {
//             setUploading(false); // Stop uploading
//         }
//     } else {
//         alert("Please select a file first.");
//     }
// };
// const handleDownload = (appId, fileType) => {
//   const url = `${API_BASE_URL}/MoreDetailsFileDownload.php?app_ID=${appId}&fileType=${fileType}`;
//   window.open(url, '_blank');
// };

 


//   return (
//     <div>
//       <Navbar />
//       <h1 className="page-title">Request Agreements</h1>
//       <Table striped bordered hover>
//         <thead>
//           <tr>
//           <th colSpan={8} className="title">
//           <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
//           <label htmlFor="status-select">All Completed Applications</label>
//           <span style={{ textAlign: 'right' }}>
//           Note: First Upload the Agreement. Then click Request Button to Send the Email.
//         </span>
//         </div>
//         </th>

//           </tr>
//           <tr>
//             <th>Application ID</th>
//             <th>User Email</th>
//             <th>Project Title</th>
//             <th>Submitted Date</th>
//             <th>Actions</th>
//             <th>Agreement (Uploaded By URC)</th>
//             <th>Agreement (Uploaded By Applicant)</th>
//           </tr>
//         </thead>

// <tbody>
//   {filteredApplications.map((app, index) => (
//     <tr key={app.Id || index}>
//       <td>{app.Id}</td>
//       <td>{app.email}</td>
//       <td>{app.projectTitle}</td>
//       <td>{app.submittedDate}</td>
//       <td>
//         <button
//           className="uploadRequest_button"
//           onClick={() => handleUploadClick(app.Id)}
//         >
//           Upload
//         </button>
//         <button
//           className={`uploadRequest_button ${app.requested ? 'requested' : ''}`}
//           onClick={() => !app.requested && handleRequestClick(app.Id)}
//           style={{
//             backgroundColor: app.requested ? 'green' : '',
//             color: app.requested ? 'white' : '',
//           }}
//           disabled={app.requested}
//         >
//           {app.requested ? 'Requested' : 'Request'}
//         </button>
//       </td>
//       <td>
//   <button className="view-button" onClick={() => handleDownload(app.Id, 'agreementurc')}>
//     Download
//   </button>
// </td>
// <td>
//   <button className="view-button" onClick={() => handleDownload(app.Id, 'agreement')}>
//     Download
//   </button>
// </td>

//     </tr>
//   ))}
// </tbody>


//       </Table>

//       <Modal show={showModal} onHide={() => setShowModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Upload File</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <input type="file" onChange={handleFileChange} />
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowModal(false)}>
//             Close
//           </Button>
//           <Button 
//             variant="primary" 
//             onClick={handleFileUpload}
//             disabled={uploading}
//           >
//             {uploading ? 'Uploading...' : 'Upload'}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }



import React, { useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Navbar from '../../Components/Navbar';
import '../Secretary/Table.css';
import axios from 'axios';
import { API_BASE_URL } from '../../config';

export default function ViewApplication() {
  const [applications, setApplications] = useState([]);
  const [filteredApplications, setFilteredApplications] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [currentAppId, setCurrentAppId] = useState(null);
  const [uploading, setUploading] = useState(false);

  // Generate years from a starting year (e.g., 2010) to the current year
  const currentYear = new Date().getFullYear();
  const startYear = 2024; // Adjust as needed
  const years = Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => startYear + i
  ).reverse(); // Reverse to show latest years first

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/RequestAgreement.php`);
        console.log('API Response:', response.data); // Debug log
        const apps = Array.isArray(response.data) ? response.data : [];
        setApplications(apps);
        if (selectedYear === "") {
          setFilteredApplications(apps);
        } else {
          setFilteredApplications(
            apps.filter((app) => {
              // Handle invalid or missing submittedDate
              if (!app.submittedDate) {
                console.warn(`Missing submittedDate for app_ID: ${app.app_ID}`);
                return false;
              }
              try {
                const appYear = new Date(app.submittedDate).getFullYear();
                return appYear === parseInt(selectedYear);
              } catch (error) {
                console.warn(`Invalid submittedDate format for app_ID: ${app.app_ID}: ${app.submittedDate}`);
                return false;
              }
            })
          );
        }
        console.log('Filtered Applications:', filteredApplications); // Debug log
      } catch (error) {
        console.error('Error fetching applications:', error);
        setApplications([]);
        setFilteredApplications([]);
      }
    };

    fetchData();
  }, [selectedYear]);

  const handleUploadClick = (id) => {
    setCurrentAppId(id);
    setShowModal(true);
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleRequestClick = async (id) => {
    const selectedApp = applications.find((app) => app.app_ID === id);
    if (!selectedApp) {
      alert("Application not found.");
      return;
    }

    const email = selectedApp.email;
    const subject = "Application Granted for Funding";
    const message = `
      Dear ${selectedApp.name},<br><br>
      We are pleased to inform you that your application titled <b>${selectedApp.projectTitle}</b>
      has been approved for funding.<br>
      <b>Start Date:</b> ${selectedApp.startDate || 'N/A'}<br>
      <b>Period:</b> ${selectedApp.period || 'N/A'}<br>
      <b>Approved Amount:</b> LKR ${selectedApp.amount || 'N/A'}<br><br>
      Please log in to the grant management system at https://rgms.pdn.ac.lk/. Navigate to Application Details > More details > Agreement to download the agreement. Once the Principal Investigator (PI) and Co-Investigators (Co-Is) have signed the agreement, please upload it to the portal.<br><br>
      Best regards,<br>
      University of Peradeniya.
    `;

    try {
      const response = await axios.post(`${API_BASE_URL}/EmailRequest.php`, {
        email,
        subject,
        message,
        appId: id,
      });

      if (response.data.status === 'success') {
        alert('Email sent and agreement table updated successfully.');
        const updatedApps = applications.map((app) =>
          app.app_ID === id ? { ...app, requested: 1 } : app
        );
        setApplications(updatedApps);
        if (selectedYear === "") {
          setFilteredApplications(updatedApps);
        } else {
          setFilteredApplications(
            updatedApps.filter((app) => {
              if (!app.submittedDate) return false;
              try {
                const appYear = new Date(app.submittedDate).getFullYear();
                return appYear === parseInt(selectedYear);
              } catch (error) {
                console.warn(`Invalid submittedDate format for app_ID: ${app.app_ID}`);
                return false;
              }
            })
          );
        }
      } else {
        alert(`Failed to send email: ${response.data.message}`);
      }
    } catch (error) {
      console.error('Error sending email:', error);
      alert('An error occurred while sending the email.');
    }
  };

  const handleFileUpload = async () => {
    if (selectedFile) {
      setUploading(true);
      const formData = new FormData();
      formData.append('app_ID', currentAppId);
      formData.append('uploadedFile', selectedFile);

      try {
        const response = await axios.post(`${API_BASE_URL}/RequestAgreement.php`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        if (response.data.status === 'success') {
          alert(response.data.message);
          setShowModal(false);
          const fetchData = async () => {
            try {
              const response = await axios.get(`${API_BASE_URL}/RequestAgreement.php`);
              console.log('Post-upload API Response:', response.data); // Debug log
              const apps = Array.isArray(response.data) ? response.data : [];
              setApplications(apps);
              if (selectedYear === "") {
                setFilteredApplications(apps);
              } else {
                setFilteredApplications(
                  apps.filter((app) => {
                    if (!app.submittedDate) return false;
                    try {
                      const appYear = new Date(app.submittedDate).getFullYear();
                      return appYear === parseInt(selectedYear);
                    } catch (error) {
                      console.warn(`Invalid submittedDate format for app_ID: ${app.app_ID}`);
                      return false;
                    }
                  })
                );
              }
            } catch (error) {
              console.error('Error fetching applications:', error);
              setApplications([]);
              setFilteredApplications([]);
            }
          };
          fetchData();
        } else {
          alert(response.data.message);
        }
      } catch (error) {
        console.error('Error uploading file:', error);
        alert('An error occurred while uploading the file.');
      } finally {
        setUploading(false);
      }
    } else {
      alert("Please select a file first.");
    }
  };

  const handleDownload = (appId, fileType) => {
    const url = `${API_BASE_URL}/MoreDetailsFileDownload.php?app_ID=${appId}&fileType=${fileType}`;
    window.open(url, '_blank');
  };

  return (
    <div>
      <Navbar />
      <h1 className="page-title">Request Agreements</h1>
      <div className="year-filter">
        <label htmlFor="year-select">Year: </label>
        <select
          id="year-select"
          value={selectedYear}
          onChange={(e) => setSelectedYear(e.target.value)}
          className="year-select"
        >
          <option value="">Select Year</option>
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th colSpan={7} className="title">
              <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <label htmlFor="status-select">All Completed Applications</label>
                <span style={{ textAlign: 'right' }}>
                  Note: First Upload the Agreement. Then click Request Button to Send the Email.
                </span>
              </div>
            </th>
          </tr>
          <tr>
            <th>Application ID</th>
            <th>User Email</th>
            <th>Project Title</th>
            <th>Submitted Date</th>
            <th>Actions</th>
            <th>Agreement (Uploaded By URC)</th>
            <th>Agreement (Uploaded By Applicant)</th>
          </tr>
        </thead>
        <tbody>
          {filteredApplications.length > 0 ? (
            filteredApplications.map((app, index) => (
              <tr key={app.app_ID || index}>
                <td>{`${app.app_ID}_${new Date().getFullYear()}`}</td>
                <td>{app.email}</td>
                <td>{app.projectTitle}</td>
                <td>{app.submittedDate}</td>
                <td>
                  <button
                    className="uploadRequest_button"
                    onClick={() => handleUploadClick(app.app_ID)}
                  >
                    Upload
                  </button>
                  <button
                    className={`uploadRequest_button ${app.requested ? 'requested' : ''}`}
                    onClick={() => !app.requested && handleRequestClick(app.app_ID)}
                    style={{
                      backgroundColor: app.requested ? 'green' : '',
                      color: app.requested ? 'white' : '',
                    }}
                    disabled={app.requested}
                  >
                    {app.requested ? 'Requested' : 'Request'}
                  </button>
                </td>
                <td>
                  <button
                    className="view-button"
                    onClick={() => handleDownload(app.app_ID, 'agreementurc')}
                  >
                    Download
                  </button>
                </td>
                <td>
                  <button
                    className="view-button"
                    onClick={() => handleDownload(app.app_ID, 'agreement')}
                  >
                    Download
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7">No applications available</td>
            </tr>
          )}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Upload File</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input type="file" onChange={handleFileChange} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={handleFileUpload}
            disabled={uploading}
          >
            {uploading ? 'Uploading...' : 'Upload'}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

// import React, { useEffect, useState } from 'react';
// import Table from 'react-bootstrap/Table';
// import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
// import Navbar from '../../Components/Navbar';
// import '../Secretary/Table.css';
// import axios from 'axios';
// import { API_BASE_URL } from '../../config';
// export default function ViewApplication() {
//   const [applications, setApplications] = useState([]);
//   const [filteredApplications, setFilteredApplications] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [currentAppId, setCurrentAppId] = useState(null);
//   const [uploading, setUploading] = useState(false);

//   useEffect(() => {
//     // Fetch applications from the PHP script
//     fetchApplications();
//   }, []);

//  const fetchApplications = async () => {
//   try {
//     const response = await axios.get('/RequestAgreement.php');

//     if (Array.isArray(response.data)) {
//       setApplications(response.data);
//       setFilteredApplications(response.data);
//     } else {
//       console.error("Expected an array but got:", response.data);
//       setApplications([]);
//       setFilteredApplications([]);
//     }
//   } catch (error) {
//     console.error('Error fetching applications:', error);
//     setApplications([]);
//     setFilteredApplications([]);
//   }
// };


//   const handleUploadClick = (id) => {
//     setCurrentAppId(id); // Set the current application ID
//     setShowModal(true); // Open the modal
//   };

//   const handleFileChange = (e) => {
//     setSelectedFile(e.target.files[0]); // Store the selected file
//   };
  
//   const handleRequestClick = async (id) => {
//     const selectedApp = applications.find((app) => app.Id === id);
//     if (!selectedApp) {
//       alert("Application not found.");
//       return;
//     }
  
//     const email = selectedApp.email;
//     const subject = "Application Granted for Funding";
//     const message = `
//       Dear ${selectedApp.name},<br><br>
//       We are pleased to inform you that your application titled <b>${selectedApp.projectTitle}</b>
//       has been approved for funding.<br>
//       <b>Start Date:</b> ${selectedApp.startDate}<br>
//       <b>Period:</b> ${selectedApp.period}<br>
//       <b>Approved Amount:</b> LKR ${selectedApp.amount}<br><br>
//       Please log in to the grant management system at https://rgms.pdn.ac.lk/. Navigate to Application Details > More details > Agreement to download the agreement. Once the Principal Investigator (PI) and Co-Investigators (Co-Is) have signed the agreement, please upload it to the portal.<br><br>
//       Best regards,<br>
//       University of Peradeniya.
//     `;
  
//     try {
//       const response = await axios.post(`${API_BASE_URL}/EmailRequest.php`, {
//         email,
//         subject,
//         message,
//         appId: id,
//       });
  
//       if (response.data.status === 'success') {
//         alert('Email sent and agreement table updated successfully.');
  
//         // Update the applications state to reflect the change
//         setApplications((prevApplications) =>
//           prevApplications.map((app) =>
//             app.Id === id ? { ...app, requested: 1 } : app
//           )
//         );
  
//         setFilteredApplications((prevFilteredApplications) =>
//           prevFilteredApplications.map((app) =>
//             app.Id === id ? { ...app, requested: 1 } : app
//           )
//         );
//       } else {
//         alert(`Failed to send email: ${response.data.message}`);
//       }
//     } catch (error) {
//       console.error('Error sending email:', error);
//       alert('An error occurred while sending the email.');
//     }
//   };
  
//   const handleFileUpload = async () => {
//     if (selectedFile) {
//         setUploading(true); // Start uploading
//         const formData = new FormData();
//         formData.append('app_ID', currentAppId); // Attach the app_ID
//         formData.append('uploadedFile', selectedFile); // Attach the file

//         try {
//             // Use axios to post the form data to the server
//             const response = await axios.post(`${API_BASE_URL}/RequestAgreement.php`, formData, {
//                 headers: {
//                     'Content-Type': 'multipart/form-data', // Important to set this for file uploads
//                 },
//             });

//             // Handle the response from the server
//             if (response.data.status === 'success') {
//                 alert(response.data.message);
//                 setShowModal(false); // Close the modal
//                 fetchApplications(); // Refresh the list of applications
//             } else {
//                 alert(response.data.message);
//             }
//         } catch (error) {
//             console.error('Error uploading file:', error);
//             alert('An error occurred while uploading the file.');
//         } finally {
//             setUploading(false); // Stop uploading
//         }
//     } else {
//         alert("Please select a file first.");
//     }
// };

//   return (
//     <div>
//       <Navbar />
//       <h1 className="page-title">Request Agreements</h1>
//       <Table striped bordered hover>
//         <thead>
//           <tr>
//           <th colSpan={6} className="title">
//           <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
//           <label htmlFor="status-select">All Completed Applications</label>
//           <span style={{ textAlign: 'right' }}>
//           Note: First Upload the Agreement. Then click Request Button to Send the Email.
//         </span>
//         </div>
//         </th>

//           </tr>
//           <tr>
//             <th>Application ID</th>
//             <th>User Email</th>
//             <th>Project Title</th>
//             <th>Submitted Date</th>
//             <th>Actions</th>
//           </tr>
//         </thead>

// <tbody>
//   {filteredApplications.map((app, index) => (
//     <tr key={app.Id || index}>
//       <td>{app.Id}</td>
//       <td>{app.email}</td>
//       <td>{app.projectTitle}</td>
//       <td>{app.submittedDate}</td>
//       <td>
//         <button
//           className="uploadRequest_button"
//           onClick={() => handleUploadClick(app.Id)}
//         >
//           Upload
//         </button>
//         <button
//           className={`uploadRequest_button ${app.requested ? 'requested' : ''}`}
//           onClick={() => !app.requested && handleRequestClick(app.Id)}
//           style={{
//             backgroundColor: app.requested ? 'green' : '',
//             color: app.requested ? 'white' : '',
//           }}
//           disabled={app.requested}
//         >
//           {app.requested ? 'Requested' : 'Request'}
//         </button>
//       </td>
//     </tr>
//   ))}
// </tbody>


//       </Table>

//       <Modal show={showModal} onHide={() => setShowModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Upload File</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <input type="file" onChange={handleFileChange} />
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowModal(false)}>
//             Close
//           </Button>
//           <Button 
//             variant="primary" 
//             onClick={handleFileUpload}
//             disabled={uploading}
//           >
//             {uploading ? 'Uploading...' : 'Upload'}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }